/**
 * Error model for the credit-ledger use-cases (load history / grant credits).
 *
 * Discriminated union built on the app-wide `@/utils/infra-error` classifier, like
 * `licences/domain/licence-error.ts`. The Credits tab needs to tell a 403 (not an
 * admin) from an offline browser, which the rest of this slice's plain-string
 * `toMessage` cannot express; hence a proper union here.
 */
import { classifyInfraError, type InfraFailure } from '@/utils/infra-error';

export type CreditsError = InfraFailure;

/** Map an infrastructure error into a domain `CreditsError`. */
export function toCreditsError(e: unknown, defaultMessage: string): CreditsError {
  return classifyInfraError(e, defaultMessage);
}

export const CREDITS_LOAD_ERROR = 'Failed to load credits.';
export const CREDITS_GRANT_ERROR = 'Failed to add credits.';
